// src/hooks/useAuthRedirect.js or .ts
import { useDispatch, useSelector } from "react-redux";
import { useAuth, useLoader } from "../context";
import { getAccesstoken, selectUserDatas } from "../store/userSlice";
import { useLocation, useNavigate } from "react-router";
import { staticVar } from "../Service/Constats";
import { useEffect } from "react";

const useAuthRedirect = () => {
  const userData = useSelector(selectUserDatas);
  const { showLoader, hideLoader } = useLoader();
  const { accessToken, logout } = useAuth();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  // Loader control (optional)
  useEffect(() => {
    if (userData.loader !== undefined) {
      userData.loader ? showLoader() : hideLoader();
    }
  }, [userData.loader]);

  useEffect(() => {
    const isLoggedIn = Boolean(accessToken);
    const hasUserID = Boolean(userData.data?.ID);
    const isIdle = userData.loading === staticVar.idle;

    if (!isLoggedIn && location.pathname !== "/login") {
      navigate("/login", { replace: true });
    } else if (!!userData.error) {
      logout();
    } else if (isLoggedIn && !hasUserID && isIdle) {
      dispatch(getAccesstoken());
    } else if (isLoggedIn && hasUserID && location.pathname === "/") {
      navigate("/campuses", { replace: true });
    }
  }, [
    accessToken,
    userData.data?.ID,
    userData.loading,
    userData.error,
    location.pathname,
    dispatch,
    navigate,
  ]);
};

export default useAuthRedirect;
